import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function OldSolutions() {
  const failures = ["Te dijeron 'disciplina' cuando lo tuyo era amenaza.", 'Te dieron hábitos gigantes cuando tú necesitabas 10 minutos.', "Te dieron 'piensa positivo' cuando tu cuerpo estaba en alerta.", 'Te hicieron creer que estar solo = estar en peligro.'];
  return <section className="py-24 px-4 bg-dark-800" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl font-bold text-white mb-12 text-center" data-id="element-102">
          Por qué lo que has intentado no te funcionó <br data-id="element-103" />
          <span className="text-gray-500 text-xl font-normal" data-id="element-104">
            (y no es tu culpa)
          </span>
        </motion.h2>

        <div className="space-y-6 mb-12" data-id="element-105">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-lg bg-dark-900/50 border border-red-900/20" data-id="element-106">
              <div className="mt-1 bg-red-900/20 p-1 rounded text-red-500" data-id="element-107">
                <X size={20} data-id="element-108" />
              </div>
              <p className="text-lg text-gray-300" data-id="element-109">{item}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center text-xl font-medium text-amber-gold" data-id="element-110">
          Y así terminas con más herramientas… y menos acción.
        </motion.p>
      </div>
    </section>;
}